<template>
  <div class="datos">
    <b-modal title="Encabezado Reporte" v-model="vModal">
      <b-input-group class="my-2" prepend="Nombre">
        <b-input autofocus size="sm" v-model="Viajero"></b-input>
      </b-input-group>
      <b-input-group class="my-2" prepend="Pasaporte">
        <b-input size="sm" v-model="Pasaporte"></b-input>
      </b-input-group>
    </b-modal>

    <b-overlay variant="success" opacity="0.5" :show="Esperar">
      <div class="dTabla w-100">
        <div class="dCelda logo">
          <div class="my-1 mx-0 text-center">
            <router-link to="/courier/reportes">
              <img src="/logo4.svg" />
            </router-link>
          </div>
        </div>
        <div  class="dCelda Direccion text-center">
          <p  @click="vModal = true" class="my-0">{{ Direccion1 }}</p>
          <p @click="vModal = true" class="my-0">{{ Direccion2 }}</p>
        </div>
        <div class="dCelda text-center">
          <div>
            <div @click="CambioMaleta">Maleta</div>
            <div class="NoMaleta">
              {{ NoMaleta }}
            </div>
          </div>
        </div>
      </div>

      <b-row class="font12 px-2 py-1">
        <b-col> <b> NOMBRE:</b> {{ Viajero }}</b-col>
        <b-col> <b> PASAPORTE: </b> {{ Pasaporte }}</b-col>
        <b-col> <b>FECHA:</b> {{ fecha }} </b-col>
      </b-row>
      <div v-if="MisEnvios.length">
      <b-table-lite small  :fields="campos" class="tabla w-100" bordered striped :items="MisEnvios">
        <template #cell(Peso)="data">
          <div class="Peso">
          {{data.item.Peso}}
          </div>
        </template>
      </b-table-lite>
      <div class="dTabla w-100 Total">
        <div class="dCelda"></div>
        <div class="dCelda texto">Total Peso:</div>
      <div class="dCelda total">{{Total}}</div>
      </div>
      </div>
      <div class="my-4 p-4" v-else>

        <b-alert :show="true" variant="danger"> <b-icon-exclamation-octagon-fill /> No hay informacion para mostrar!</b-alert>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

let Fixed = function(v) {
  if (typeof v == "string") v = parseFloat(v);
  return v.toFixed(2);
};

export default {
  mounted() {
    let viajes = JSON.parse(localStorage.Viajes);
    let trip = viajes.filter((v) => {
      return v.id == this.viaje;
    })[0];
    let f = new Date(trip.fecha);

    this.fecha = f.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
  },
  computed: {
    allMaletas() {
      var Maletas = [...new Set(this.Datos.map((env) => env.Maleta))];

      let def=Maletas.filter(item=>!item==false)
      

      return def;
    },
    NoMaleta() {
      let total = this.allMaletas.length;
      let rs = this.selMaleta + "/" + total;

      return rs;
    },
    Total() {
      
      let envios = this.MisEnvios;
      
      let t = 0.00;

      envios.forEach(element => {
   t += parseFloat(element.Peso) 
   });

  

      return t.toFixed(2);
    },
    MisEnvios() {
      let maleta = this.selMaleta;

      let envios = this.Datos.filter((envio) => {
        return envio.Maleta == maleta;
      });

      return envios;
    },
  },
  methods: {
    CambioMaleta() {
      let siguiente = this.selMaleta + 1;

      siguiente = siguiente > this.allMaletas.length ? 1 : siguiente;

      this.selMaleta = siguiente;
    },
  },
  created() {
    let valor = this.viaje;

    this.$bind("Envios", db.collection("Envios").where("Viaje", "==", valor)).then(() => {
      this.Esperar = false;
    });
  },
  data() {
    return {
      vModal: false,
      fecha: new Date().toLocaleDateString(),
      selPak: null,
      selGuia: null,
      selMaleta: 1,
      Esperar: true,
      Envios: [],
      Datos: [],
      Direccion1: "1 AVE 7-027 ZONA 2 SANARATE EL PROGRESO TEL 7925-2608",
      Direccion2: "627 TYLER ST OAKLAND CA 94603 TEL (510) 575-6303",
      Viajero: "LUIS RODOLFO DIAZ SILIEZAR",
      Pasaporte: "171081110",
      maleta: null,
      campos: ["Guia", "Envia", "Recibe", "Paquete", "Contenido", "Peso" ],
    };
  },
  watch: {
    async Envios(v) {
      if (v.length > 0) {
        let envs = [];
        let clientes = [];
        let ClientesID = v.map((item) => item.Recibe);

        ClientesID = ClientesID.concat(v.map((item) => item.Envia));

        do {
          let IDs = ClientesID.slice(0, 10);
          ClientesID.splice(0, 10);

          await db
            .collection("Cliente")
            .where(firebase.firestore.FieldPath.documentId(), "in", IDs)
            .get()
            .then((tmp) => {
              let datos = tmp.docs.map((c) => {
                let da = c.data();
                return {
                  id: c.id,
                  Nombre: da.Nombre,
                };
              });

              clientes = clientes.concat(datos);
            });
        } while (ClientesID.length > 0);

        v.forEach((item) => {
          let recibe = clientes.filter((cli) => cli.id == item.Recibe)[0].Nombre;
          let envia = clientes.filter((cli) => cli.id == item.Envia)[0].Nombre;

          let i = 1;
          item.Contenido.filter((cn) => cn.Tipo == "Paquete").forEach((c) => {
            if (c.Contenido.length > 0) {
              let p = {
                id: item.id,
                Guia: item.NoGuia,
                Envia: envia,
                Recibe: recibe,
                Paquete: i,
                Peso: Fixed(c.Peso),
                Contenido: c.Contenido.map((cc) => cc.Cantidad + " " + cc.Producto).join(", "),
                Maleta: item["Pak" + i] ,
              };

              envs.push(p);

              i++;
            }
          });
        });

        this.Datos = envs;
      }
    },
  },

  props: ["viaje"],
  beforeCreate() {
    this.$root.$emit("Imprimir", { ok: true });
  },
};
</script>
<style scoped>
.datos {
  width: 19.5cm;
  border: 1p solid black;
}
.tabla {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0px;
}
.Direccion > p {
  font-size: 12px;
}
.font12 {
  font-size: 12px;
}
.logo {
  width: 225px;
  table-layout: fixed;
}
.dTabla {
  display: table;
  border-bottom: 1px solid #999;
}
.dCelda {
  display: table-cell;
}
.NoMaleta {
  border: 2px solid black;
}
.total{
  table-layout: fixed;
  width: 50px;
}
.Total{
  font-size: 12px;
  border: 1px solid rgb(222, 226, 230);
}
.texto{
  table-layout: fixed;
  width: 75px;
}
.Peso{
  width: 50px !important;
}
</style>
